// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2czhK","right":"styles_right__2SH-u"};